import { render, staticRenderFns } from "./TranslationConfigurationHierarchyService.vue?vue&type=template&id=11183ea3&scoped=true&"
import script from "./TranslationConfigurationHierarchyService.vue?vue&type=script&lang=js&"
export * from "./TranslationConfigurationHierarchyService.vue?vue&type=script&lang=js&"
import style0 from "./TranslationConfigurationHierarchyService.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TranslationConfigurationHierarchyService.vue?vue&type=style&index=1&id=11183ea3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11183ea3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VIcon,VRow,VTreeview})
